// destinations img
import tour4 from "../assets/images/tour/albania.png";      
import tour5 from "../assets/images/tour/barcelona.png";  
import tour6 from "../assets/images/tour/prague.png";      
import tour7 from "../assets/images/tour/dubai.png";        
import tour8 from "../assets/images/tour/cape-town.png";   
import tour9 from "../assets/images/tour/santorini.png";    
import tour10 from "../assets/images/tour/paris.png";   
import tour11 from "../assets/images/tour/zurich.png"; 

// populars img
import Santorini from "../assets/images/popular/Santorini.jpg";
import Barcelona from "../assets/images/popular/Barcelona.jpg";
import Paris from "../assets/images/popular/Paris.jpg";
import Amsterdam from "../assets/images/popular/Amsterdam.jpg";
import Italy from "../assets/images/popular/Italy.jpg";
import Frankfurt from "../assets/images/popular/Frankfurt.jpg";
import Stamboll from "../assets/images/popular/Stamboll.jpg";
import Monaco from "../assets/images/popular/Monaco.jpg";

// tour detail img
import image1 from "../assets/images/new/1.jpg";
import image2 from "../assets/images/new/2.jpg";
import image3 from "../assets/images/new/3.jpg";
import image4 from "../assets/images/new/4.jpg";
import image5 from "../assets/images/new/5.jpg";
import image6 from "../assets/images/new/6.jpg";
import image7 from "../assets/images/new/7.jpg";
import image8 from "../assets/images/new/8.jpg";

export const destinationsData = [
  {
    id: 0,
    name: "Albania",
    tours: "5 tours and activities",
    image: tour4,
    link: "/tours/albania",
    shortDes: "",
  },
  {
    id: 1,
    name: "Barcelona",
    tours: "9 tours and activities",
    image: tour5,
    link: "/tours/barcelona",
  },

  {
    id: 2,
    name: "Prague",
    tours: "5 tours and activities",
    image: tour6,
    link: "/tours/prague",
  },

  {
    id: 3,
    name: "Dubai",
    tours: "4 tours and activities",
    image: tour7,
    link: "/tours/dubai",
  },
  {
    id: 4,
    name: "Cape-Town",
    tours: "9 tours and activities ",
    image: tour8,
    link: "/tours/cape-town",
  },
  {
    id: 5,
    name: "Santorini",
    tours: "4 tours and activities",
    image: tour9,
    link: "/tours/santorini ",
  },
  {
    id: 6,
    name: "Paris",
    tours: "6 tours and activities",
    image: tour10,
    link: "/tours/paris",
  },
  {
    id: 7,
    name: "Zurich",
    tours: "4 tours and activities",
    image: tour11,
    link: "/tours/zurich",
  },
];

export const popularsData = [
  {
     id: 0,
     title: "Experience Vibrant Barcelona",
     image: Barcelona, 
     location: "Barcelona, Spain",
     category: ["City Break", "Cultural Tour"],
     days: "6 days - 5 nights",
     price: 120,
     afterDiscount: 99,
     rating: 4,
     reviews: 12,
   },
   {
    id: 1,
    title: "Romantic Escape in Paris",
    image: Paris,
    location: "Paris, France",
    category: ["City Break", "Cultural Tour"],
    days: "5 days - 4 nights",
    price: 210,
    afterDiscount: 179,
    rating: 5,
    reviews: 34,
  },
  {
    id: 2,
    title: "Charming Canals of Amsterdam",
    image: Amsterdam,
    location: "Amsterdam, Netherlands",
    category: ["City Tour", "Cultural Exp"],
    days: "3 days - 2 nights",
    price: 140,
    afterDiscount: 125,
    rating: 4,
    reviews: 21,
  },
  
  {
    id: 3,
    title : "Sunsets in Santorini",
    image: Santorini,
    location: "Santorini, Greece",
    category: ["Island Escape", "Historical Tour"],
    days: "1 days - 9 hours",
    price: 434,
    afterDiscount: 0,
    rating: 5,
    reviews: 20,
  },
  {
    id: 4,
    title: "Italian Heritage Tour",
    image: Italy, 
    location: "Rome, Italy",
    category: ["Cultural Exp", "Historical Tour"],
    days: "2 days - 6 hours",
    price: 550,
    afterDiscount: 0,
    rating: 4.5,
    reviews: 18,
  },
  {
    id: 5,
    title: "Stamboll Getaway",
    image: Stamboll, 
    location: "Istanbul, Turkey",
    category: ["City Break", "Cultural Exp"],
    days: "3 days - 2 nights",
    price: 120,
    afterDiscount: 0,
    rating: 4,
    reviews: 15,
  },
  {
    id: 6,
    title: "Monaco Luxury Escape",
    image: Monaco, 
    location: "Monte Carlo, Monaco",
    category: ["Cultural Exp", "City Break"],
    days: "2 days - 1 night",
    price: 250,
    afterDiscount: 0,
    rating: 5,
    reviews: 9,
  },
  {
    id: 7,
    title: "Frankfurt City Tour",
    image: Frankfurt, 
    location: "Frankfurt, Germany",
    category: ["Escorted Tour", "Historical Tour"],
    days: "4 days - 3 nights",
    price: 85,
    afterDiscount: 0,
    rating: 3,
    reviews: 11,
  },
];

export const tourDetails = {
  title: "Beautiful Bali with Malaysia",
  des: ` Bali, also known as the land of gods has plenty to offer to travelers from across the globe. As it so contrasted oh estimating instrument. Size like body some one had.  Are conduct viewing boy minutes warrant the expense?  Tolerably behavior may admit daughters offending her ask own. Praise effect wishes change way and any wanted.  Lively use looked latter regard had. Do he it part more  last in. We understand that theory is important to build a solid foundation, we understand that theory alone isn’t going to get the job done so that’s why this is packed with practical hands-on examples that you can  follow step by step.`,
  price: "280.00",
  rating: " 4.5",
  reviews: "365 reviews",
  tourInfo: [
    '<strong className="font-bold"> Place Covered</strong>: Bali - Ubud',
    ' <strong className="font-bold">Duration:</strong>5 Days, 4 Nights',
    '<strong className="font-bold">Start Point:</strong> Ngurah International Airport',
    '<strong className="font-bold">End Point:</strong>  Ngurah International Airport',
  ],

  highlights: [
    " Experience a delightful tropical getaway with a luxurious stay and witness the picture-perfect beaches, charming waterfalls and so much more",
    " Dependent on so extremely delivered by. Yet no jokes  worse her why. Bed one supposing breakfast day fulfilled off depending questions.",
    " Whatever boy her exertion his extended. Ecstatic  followed handsome drawings entirely Mrs one yet  outweigh.",
    "Meant balls it if up doubt small purse. Required his  you put the outlived answered position. A pleasure exertion if believed provided to.",
  ],

  itinerary: [
    {
      title: `<span class="me-1 fw-bold">Day 1:</span>  Airport Pick Up `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
    },

    {
      title: `<span class="me-1 fw-bold">Day 2:</span>  Temples & River Cruise `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in. `,
    },
    {
      title: `<span class="me-1 fw-bold">Day 3:</span>  Massage & Overnight Train`,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
    },
    {
      title: `<span class="me-1 fw-bold">Day 4:</span>  Khao Sok National Park `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.`,
    },
    {
      title: `<span class="me-1 fw-bold">Day 5:</span>  Travel to Koh Phangan `,
      des: ` Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.
      `,
    },
    {
      title: `<span class="me-1 fw-bold">Day 6:</span> Morning Chill & Muay Thai Lesson `,
      des: `Like on all of our trips, we can collect you from the airport when you land and take you directly to your hotel. The first Day is just a check-in Day so you have this freedom to explore the city and get settled in.
      `,
    },
  ],

  included: [
    "Comfortable stay for 4 nights in your preferred category Hotels",
    "Professional English speaking guide to help you explore the cities",
    "Breakfast is included as mentioned in Itinerary.",
    "Per Peron rate on twin sharing basis",
    "Entrance Tickets to Genting Indoor Theme Park    ",
    "All Tours & Transfers on Seat In Coach Basis ",
    "Visit Bali Safari & Marine Park with Jungle Hopper Pass    ",
  ],
  exclusion: [
    "Lunch and dinner are not included in CP plans",
    "Any other services not specifically mentioned in the inclusions",
    "Medical and Travel insurance",
    "Airfare is not included ",
    "Early Check-In & Late Check-Out ",
    "Anything which is not specified in Inclusions    ",
  ],

  images: [
    {
      original: image1,
      thumbnail: image1,
    },
    {
      original: image2,
      thumbnail: image2,
    },
    {
      original: image3,
      thumbnail: image3,
    },
    {
      original: image4,
      thumbnail: image4,
    },
    {
      original: image5,
      thumbnail: image5,
    },

    {
      original: image6,
      thumbnail: image6,
    },
    {
      original: image7,
      thumbnail: image7,
    },
    {
      original: image8,
      thumbnail: image8,
    },
  ],
};

export const location = [
  "Bali",
  "Tokyo",
  "Bangkok",
  "Cancun",
  "Nha Trang",
  "Phuket",
  "Malaysia",
  "Paris",
];

export const Categories = [
  "History",
  "Culture",
  "Netural",
  "Urban Tour",
  "Relax",
];

export const Duration = ["1-3 Days", "3-5 Days", "5-7 Days", "7-10 Day"];
export const PriceRange = [
  "$ 0 - $50",
  "$ 50 - $ 100",
  "$ 100 - $ 200",
  "$ 200 - ₹ $ 400",
  "$ 400 - ₹ $ 800",
];

export const Ratings = ["⭐", "⭐⭐", "⭐⭐⭐", "⭐⭐⭐⭐", "⭐⭐⭐⭐⭐"];


export const contactCards = [
  {
    img: "contact1.png",
    title: "Self Service",
    text: "We aim to meet all customer requests, but some situations are beyond our agents' assistance. You can find solutions below.",
    button: "SEE SOLUTION",
  },
  {
    img: "contact2.png",
    title: "CHAT WITH ANA",
    text: "For quick help, talk to our virtual assistant, available 24/7 for booking, flight status, baggage, and WEX services questions.",
    button: "START CHAT",
  },
  {
    img: "contact3.png",
    title: "Claims and refunds",
    text: "Submit a claim for flight or service issues, baggage problems, or booking troubles.",
    button: "MAKE A CLAIM",
  },
];



export const helpItems = [
  {
    icon: "bi-airplane-engines",
    title: "Flight Status",
    description: "Check the live updates on the flight status, up to 48 hours in advance."
  },
  {
    icon: "bi-person-circle",
    title: "My WEX Account",
    description: "Benefits and functionalities of your WEX Account."
  },
  {
    icon: "bi-suitcase-lg",
    title: "Booking information and services",
    description: "Baggage policy, available services, tips if travelling with children and more."
  },
  {
    icon: "bi-arrow-left-right",
    title: "Booking modification",
    description: "Find out how to change or cancel your flight, change passenger details…"
  },
  {
    icon: "bi-ticket-perforated",
    title: "Check-in and boarding",
    description: "Check-in and boarding, and required documents."
  },
  {
    icon: "bi-arrow-counterclockwise",
    title: "Delay, cancellation and refund",
    description: "Delayed or cancelled flight and guideline for refund."
  },
  {
    icon: "bi-bag-x",
    title: "Damaged, lost bags and items",
    description: "If your baggage was delayed or damaged, please let us know."
  },
  {
    icon: "bi-headset",
    title: "Contact us",
    description: "Need some help? Find the best way to get answer to your question!"
  }
];